import { CommonBridgeEngine } from './commonBridgeEngine';
class MyError extends Error {
    constructor(message, options) {
        super(message);
        this.code = -1;
        this.duration = [];
        this.code = options.code;
        this.duration = options.duration;
    }
    print() {
        console.log('[custom-error]', this.code, this.duration);
        return true;
    }
}
export class MasterBridgeEngine extends CommonBridgeEngine {
    constructor() {
        super();
        this.requestList = new Map();
        this.requestStarttimeMap = new Map();
        this.init();
    }
    getConfigureTaskPriority() {
        return this.renderChannelApi.invoke({
            eventName: 'getConfigureTaskPriority',
            params: {},
        });
    }
    init() {
        this.renderChannelApi.addResponseListener(args => {
            this.handleResponseExchangeData(args);
            return true;
        });
    }
    configureApiPriority(taskInfo, priority, overtime) {
        return this.renderChannelApi.invoke({
            eventName: 'configureApiPriority',
            params: {
                taskInfo,
                priority,
                overtime,
            },
        });
    }
    async handleResponseExchangeData(args) {
        const { ackNo, data, code, errorMsg, duration: timestampList } = args;
        if (!this.requestList.has(ackNo)) {
            return;
        }
        const { reject, resolve } = this.requestList.get(ackNo);
        this.requestList.delete(ackNo);
        if (code === 0) {
            resolve({
                data,
                duration: timestampList,
            });
        }
        else {
            const error = new MyError(errorMsg, {
                code,
                duration: timestampList,
            });
            reject(error);
        }
        this.requestStarttimeMap.delete(ackNo);
    }
    flush() {
        return this.renderChannelApi.invoke({
            eventName: 'flush',
            params: {},
        });
    }
    async dispatchTask(args, seqNo, winType = 'main') {
        this.requestStarttimeMap.set(seqNo, Date.now());
        try {
            await this.renderChannelApi.invoke({
                eventName: 'dispatchTask',
                params: {
                    requestContent: args,
                    seqNo,
                    winType,
                    channelId: this.renderChannelApi.getChannelId(),
                },
            });
        }
        catch (ex) {
            console.log('[bridge]dispatchTask error:', ex, 'args:', args);
            return Promise.reject(typeof ex === 'string' ? new Error(ex) : ex);
        }
        return new Promise((resolve, reject) => {
            this.requestList.set(seqNo, {
                resolve,
                reject,
            });
        });
    }
    async getAllTasks() {
        const res = await this.renderChannelApi.invoke({
            eventName: 'getAllTasks',
            params: {},
        });
        return res;
    }
    async forbiddenBgWin() {
        return this.renderChannelApi.invoke({
            eventName: 'forbiddenBgWin',
            params: {},
        });
    }
    async enableBgWin() {
        return this.renderChannelApi.invoke({
            eventName: 'enableBgWin',
            params: {},
        });
    }
    async checkBgAlive(account) {
        console.log('[web-bridge]checkBgAlive:', account);
        return true;
    }
    async removeBridgeWin(webId) {
        console.log('[web-bridge]removeBridgeWin:', webId);
        return true;
    }
}
